// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"295":"3331e62dad","364":"0b39b4c705","603":"dd5087751a","863":"73a1018b70"}[chunkId] + ".js";
};